import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import classes from "./PinInput.module.css";
import InactiveIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/Pin/default - Off.svg"
import HiddenIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/HiddenPin.svg";
import managerOnly from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/PinIcon-Manager/crown_grey.png"
import battery100 from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/SensorIcons/battery_100.png";
import signal0 from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_0.png";
import signal25 from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_25.png";
import signal50 from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_50.png";
import signal75 from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_75.png";
import signal100 from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_100.png";
import tankFull from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/tank-full.png";
import tankMost from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/tank-most.png";
import tankHalf from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/tank-half.png";
import tankLow from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/tank-low.png";
import tankEmpty from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/tank-empty.png";
import tankDefault from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/tank-default.png";

// Matches the battery colour thresholds used for sensors elsewhere in the portal (e.g. padlocksList.js).
const batteryColour = (level) => {
    if (level == null) return "#9e9e9e";
    if (level <= 5) return "rgb(220,114,119)";
    if (level < 20) return "rgb(248,183,131)";
    return "rgb(101,151,100)";
}

const signalIconFor = (level) => {
    if (level == null) return signal0;
    if (level >= 75) return signal100;
    if (level >= 50) return signal75;
    if (level >= 25) return signal50;
    if (level > 0) return signal25;
    return signal0;
}

const getTankFullness = (height, ullage) => {
    if (!height) return null;
    const heightInMm = height * 10;
    const liquidAmount = heightInMm - ullage;
    const percentFull = (liquidAmount / heightInMm) * 100;
    return percentFull.toFixed(0);
}

const tankIconFor = (percentFull) => {
    if (percentFull == null) return tankDefault;
    if (percentFull >= 75) return tankFull;
    if (percentFull >= 50) return tankMost;
    if (percentFull >= 25) return tankHalf;
    if (percentFull >= 3) return tankLow;
    return tankEmpty;
}

const tankColour = (percentFull) => {
    if (percentFull <= 3) return "red";
    if (percentFull < 50) return "rgb(210, 119, 45)";
    return "rgb(98, 98, 98)";
}

const PinInput = ({ InputPin, polarity }) => {
    const { pinName, pinStatusOff, pinStatusOn, pinState, icon, accessLevel, active, battery, batteryPercentage, ullage, tankHeight, signalStrength, lastSeen } = InputPin;

    console.log("InputPin", InputPin);
    console.log("tankHeight", tankHeight);

    // Newer wireless sensors (e.g. tank/radar sensors) report batteryPercentage instead of battery.
    const batteryLevel = batteryPercentage ?? battery ?? null;

    const rawTankFullness = ullage != null ? getTankFullness(tankHeight, ullage) : null;
    const tankPercent = rawTankFullness != null ? Number(rawTankFullness) : null;

    const lowerCaseStringIcon = icon?.toLowerCase();
    const image = lowerCaseStringIcon + " - Off";
    const otherStateImage = icon + " - On";
    const staticPath = "/assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/";
    const isManagerOnly = accessLevel === "manager" ? true : false
    const imageFromPath = `${process.env.PUBLIC_URL}${staticPath}${image}.png`
    let otherStateImageFromPath = `${process.env.PUBLIC_URL}${staticPath}${otherStateImage}.png`;

    const initialPinState = polarity === 0 ? !pinState : pinState;
    const [PinState, setPinState] = useState();

    // const PinClickedHandler = () => {
    //     console.log("Changing Status");
    //     setPinState((prevPinState) => !prevPinState)
    // }

    useEffect(() => {
        setPinState(initialPinState);
    }, [pinState]);

    return (
        <div className={classes["layout"]} style={{ opacity: !active && "50%" }} >
            {/* {!active && <div className={classes["inactiveMessage-container"]}><h2>Pin Hidden</h2></div>} */}
            {!active &&
                <div className={classes["overlay"]}>
                    {/* <div className={classes.line} />
                    <div className={classes.line2} />
                    <img className={classes.HiddenIcon} src={HiddenIcon}></img> */}
                </div>}
            <div className={classes["pin-output"]}>
                <img className={active ? PinState ? classes.imgDeactivated : classes.imgActivated : classes.img} src={active ? PinState ? imageFromPath : otherStateImageFromPath : InactiveIcon} />

                <div className={classes.inputRow}>
                <div className={classes["text-wrapper"]}>
                    <div className={classes.innerPinNameRow}>
                        <h3 style={{color:"#737373", fontWeight:"450"}} className={classes.pinName}>{pinName}</h3>
                        {isManagerOnly && <img className={classes.imgManager} src={managerOnly} />}
                    </div>
                    {ullage == null && (
                        <h2 className={`${classes["pinLable"]} ${active ? PinState ? classes["deactivated"] : classes["activated"] : classes["Inactive"]}`}>
                            {active ? PinState ? pinStatusOff : pinStatusOn : "Inactive"}
                        </h2>
                    )}
                    {/* 
                    {ullage != null && (
                        <span className={classes.ullageText}>{`Ullage: ${ullage}mm`}</span>
                    )}
                    */}
                </div>

                {(batteryLevel != null || signalStrength != null || lastSeen) && ullage == null && (
                    <div className={classes.sensorStatusGroup}>
                        <div className={classes.sensorStatusIcons}>
                            {batteryLevel != null && (
                                <div className={classes.batteryIndicator}>
                                    <p className={classes.batteryPercentageText}>{`${batteryLevel.toFixed(0)}%`}</p>
                                    <div
                                        className={classes.batteryIcon}
                                        style={{
                                            backgroundColor: batteryColour(batteryLevel),
                                            WebkitMaskImage: `url(${battery100})`,
                                            WebkitMaskSize: "contain",
                                            WebkitMaskRepeat: "no-repeat",
                                            WebkitMaskPosition: "center",
                                            maskImage: `url(${battery100})`,
                                            maskSize: "contain",
                                            maskRepeat: "no-repeat",
                                            maskPosition: "center",
                                        }}
                                    />
                                </div>
                            )}
                            {signalStrength != null && (
                                <img className={classes.signalIcon} src={signalIconFor(signalStrength)} alt="Signal strength" />
                            )}
                        </div>
                        {lastSeen && (
                            <span className={classes.lastSeenText}>{format(new Date(lastSeen), "dd/MM/yyyy")}</span>
                        )}
                    </div>
                )}

                {/* tank icon */}
                {ullage != null && (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginRight: "18px", backgroundColor: "white"}}>
                        <img className={classes.tankIcon} src={tankIconFor(tankPercent)} alt="Tank level"/>
                            <p className={classes.percentageText} style={{ color: tankPercent != null ? tankColour(tankPercent) : "rgb(98, 98, 98)" }}>{tankPercent != null ? `${tankPercent}%` : ""}</p>
                    </div>
                )}
            </div>
            </div>

            <div className={active ? PinState ? classes["pin-deactivated"] : classes["pin-activated"] : classes["pin-Inactive"]} />
        </div>
    )
}

export default PinInput;